/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandThumbDownIcon16Solid = forwardRef('HandThumbDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m11 10-3.613 5.42A1.303 1.303 0 0 1 5 14.697V11H2.062a2 2 0 0 1-1.94-2.485l1.31-5.243A3 3 0 0 1 4.342 1H11v9Z" }),
        React.createElement("path", { d: "M14 10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2v9h2Z" })));
});
